"use strict";

exports.__esModule = true;
exports["default"] = singletonCache;

function singletonCache(equals) {
  var entry = undefined;
  return {
    get: function get(key) {
      if (entry && equals(key, entry.key)) {
        return entry.value;
      }
    },

    put: function put(key, value) {
      entry = { key: key, value: value };
    }
  };
}

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/lru-memoize/lib/singletonCache.js
 ** module id = 970
 ** module chunks = 0
 **/